<template>
  <div class="lb">
    <div
      class="text-area"
      ref="content"
      @mouseenter="mouseenterEvent()"
      @mouseleave="mouseleaveEvent()"
    >
      <div class="list-content" ref="scroll1">
        <div class="lt-left-item" v-for="(item, i) in scopelist" :key="i">
          <div class="lt-left-head">
            <p>TOP.{{ i + 1 }}</p>
            <div>
              <p>{{ item.value1 }}</p>
            </div>
            <p class="head-value">
              {{ (item.value2 / 10000).toFixed(2).replace(/(\.00|\.0)$/, "")
              }}{{ defaultdata[0].value3 }}
            </p>
          </div>
          <div class="bottom-area">
            <div
              class="bottom-active"
              :title="`${item.value2}${defaultdata[0].value3}`"
              :style="{
                width: (+item.value2 / +scopelist[0].value2) * 100 + '%',
              }"
            >
              <div class="bottom-border"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="list-content" ref="scroll2" v-if="scopelist.length > 5">
        <div class="lt-left-item" v-for="(item, i) in scopelist" :key="i">
          <div class="lt-left-head">
            <p>TOP.{{ i + 1 }}</p>
            <div>
              <p>{{ item.value1 }}</p>
            </div>
            <p class="head-value">
              {{ (item.value2 / 10000).toFixed(2).replace(/(\.00|\.0)$/, "")
              }}{{ defaultdata[0].value3 }}
            </p>
          </div>
          <div class="bottom-area">
            <div
              class="bottom-active"
              :title="`${item.value2}${defaultdata[0].value3}`"
              :style="{
                width: (+item.value2 / +scopelist[0].value2) * 100 + '%',
              }"
            >
              <div class="bottom-border"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as methods from './method.js'
export default {
  name: 'template.scope49',
  props: {
    vdata: {
      type: [Array, String],
      default: () => []
    },
    jsondata: {
      type: [Array, String],
      default: () => []
    },
    scopedata: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      title: '循环滚动水平条形图-scope49',
      timer: null,
      defaultdata: [
        { value1: "系列一", value2: "1000", value3: "万元" },
        { value1: "系列二", value2: "900" },
        { value1: "系列三", value2: "800" },
        { value1: "系列四", value2: "700" },
        { value1: "系列五", value2: "600" },
        { value1: "系列六", value2: "500" },
        { value1: "系列七", value2: "400" },
        { value1: "系列八", value2: "300" },
        { value1: "系列九", value2: "200" },
        { value1: "系列十", value2: "100" },
      ],
      valueMap: [
        { name: "名称", key: "value1" },
        { name: "数值", key: "value2" },
        { name: "单位", key: "value3" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      scopelist: [],
    }
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
      }
    },
    jsondata(n) {
      this.exceldata = n
    },
    defaultdata(n) {
      this.Drawdata()
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null
  },
  methods: {
    ...methods,
    rollUp(t) {
      const ulf1 = this.$refs.scroll1;
      const box = this.$refs.content;
      if (ulf1.offsetHeight > 200) {
        box.scrollTop = 0;
        this.timer = window.setInterval(this.rollStart, t);
      }
    },
    rollStart() {
      const ulf1 = this.$refs.scroll1
      const box = this.$refs.content
      if (box.scrollTop >= ulf1.scrollHeight) {
        box.scrollTop = 0;
      } else {
        box.scrollTop += 2;
      }
    },
    mouseenterEvent() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    mouseleaveEvent(t) {
      if (!this.timer) {
        this.timer = setInterval(this.rollStart, 150);
      }
    },
    Drawdata() {
      let linedata = JSON.parse(JSON.stringify(this.defaultdata));
      linedata = linedata.sort((a, b) => +b.value3 - +a.value3).slice(0, 10);
      this.scopelist = linedata;
    },
  },
  created() {

  },
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata
    }
    this.setData()
    this.Drawdata(); //需要刷新的数据
    this.$nextTick(() => {
      this.rollUp(150)
    })
  },
}
</script>

<style scoped lang="scss">
.lb {
  width: 435px;
  height: 240px;
  display: flex;
  position: relative;
  padding: 10px 0;
}

.cmain {
  width: 435px;
  height: 240px;
}

.lt-left {
  width: 100%;
  overflow: hidden;
}

.lt-left-item {
  margin-top: 8px;
}

.bottom-area {
  margin-top: 8px;
  width: 100%;
  background: #1f2a30;
  border-radius: 10px;
  height: 10px;
  position: relative;

  .bottom-active {
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .bottom-border {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    animation: name duration timing-function delay iteration-count direction
      fill-mode;
    background: linear-gradient(
      to right,
      rgba(10, 114, 252, 0.6),
      rgba(10, 114, 252, 1)
    );
    animation: borderactive 7.5s infinite linear;
  }
}

@keyframes borderactive {
  0% {
    width: 0%;
  }

  33% {
    width: 100%;
  }

  100% {
    width: 100%;
  }
}

.lt-left-head {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #bcc1ca;
  width: 100%;

  div {
    display: inline-block;
    max-width: 160px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  > p {
    &:first-child {
      width: 50px;
    }

    & + p {
      margin-left: 20px;
    }
  }

  .head-value {
    margin-left: auto;
    color: #faec00;
  }
}

.text-area {
  pointer-events: auto;
  width: 100%;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0;
  }
}
</style>